import React from 'react'; 
import './Hours.css'; 
import './Home.css'; 
import 'aos/dist/aos.css'; 
import '../The-Gallery/Visit-Us/Visit-Us.css'; 

function StuffMandarin() {

    return (
        <div id="stuff"> 
          <h1 style={{textAlign:"left"}} className="sub-stuff">看看我们的网上商店</h1> 
          <h3 style={{textAlign:"left"}} className="paragraph-stuff">
              从抽象表现主义到异想天开的波普艺术，我们想让你找到
              自己是一件能引起你共鸣的独特作品！网上商店的内容
              是有限的，每幅画都是同类中唯一的一幅，但不要再浪费了
              是时候阅读它了，你可以亲自来了解一下！
              </h3> 
        </div>
    );
  }
  
  export default StuffMandarin; 